// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"477":"135490af","515":"31c47aea","652":"9f7514e6","982":"1adea82d"}[chunkId] + ".chunk.css";
};